import { useState, useEffect, useRef, memo, useMemo } from "react";
import style from "./../index.module.scss";
import styleUi from "./UploadAni.module.scss";
import allStyle from "./../../comm/global/all.module.scss";
import { v4 } from "uuid";
import styled from "styled-components";
import { CSSTransition } from 'react-transition-group';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import * as YStyled from "../../Styleds";
import SpriteAni from "../../comm/global/components/SpriteAni";

const UploadAni = ({ setModalType, arg, addModalType }) => {
    const [inProp, setInProp] = useState(false);
    const playerRef = useRef(null);
    const isOpen = useRef(false);
    useEffect(() => {
        setInProp(true);
        arg.fnArr.doCloseFn = () => {
            playerRef.current.continue();
        }
    }, [])
    function generateArray(start, end) {
        return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
   
    return (
        <div className={style.modalBottom}>
            <CSSTransition in={inProp} timeout={{
                appear: 0,
                enter: 300,
                exit: 0,
            }} classNames={{
                enterActive: style.UpPageEnterActive,
                enterDone: style.UpPageEnterDone,
                exitActive: style.UpPageExit,
                exitDone: style.UpPageExitActive
            }}
            >
                <div className={`${style.UpPage}`} >
                    <CSSTransition in={inProp} timeout={{
                        appear: 0,
                        enter: 300,
                        exit: 0,
                    }} classNames={{
                        enterActive: style.UpPageEnterActive,
                        enterDone: style.UpPageEnterDone,
                        exitActive: style.UpPageExit,
                        exitDone: style.UpPageExitActive
                    }}
                        onExited={async () => {
                            await new Promise(resolve => requestAnimationFrame(resolve));
                            setModalType(prev => prev.filter(v => v.cls !== "UploadAni"))
                        }}
                    >
                        <div className={`${style.UpPage} ${style.page}`} id="background" onClick={event => {
                            if (event.target.id == "background") {
                                //modalThrough 的話點不到 ，也不合理
                            }
                        }}>
                            <div className={styleUi.app}>
                                <div className={styleUi.ani}>
                                    <SpriteAni
                                        className={styleUi.player} ref={playerRef}
                                        img="./sprite.png"
                                        xCount={13}
                                        yCount={6}
                                        defaultFrames={generateArray(0, 13 * 6 - 7)}
                                        sloops={[35, 44]}
                                        sloopsCb={() => {
                                            if(isOpen.current===false)
                                            {
                                                isOpen.current=true;
                                                arg.cb("loop")
                                            }
                                        }}
                                        frameSec={.1}
                                        loop={false}
                                        onComplete={() => {
                                            console.log("done");
                                            arg.cb("end")
                                            setInProp(false)
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </CSSTransition>
                </div>
            </CSSTransition>
        </div>
    );
}

export default memo(UploadAni);